var _path, _path2, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.347826 24C0.347826 10.9373 10.9373 0.347826 24 0.347826C37.0627 0.347826 47.6522 10.9373 47.6522 24C47.6522 37.0627 37.0627 47.6522 24 47.6522C10.9373 47.6522 0.347826 37.0627 0.347826 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.347826 24C0.347826 10.9373 10.9373 0.347826 24 0.347826C37.0627 0.347826 47.6522 10.9373 47.6522 24C47.6522 37.0627 37.0627 47.6522 24 47.6522C10.9373 47.6522 0.347826 37.0627 0.347826 24Z",
    stroke: "#AEB0B6",
    strokeWidth: 0.695652
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_944_5529",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_944_5529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.127 24.25H16V22.75H28.127L22.4308 17.0538L23.5 16L31 23.5L23.5 31L22.4308 29.9462L28.127 24.25Z",
    fill: "#46474C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.5ad41cb66889306081bb1eaf792b1635.svg";
export { ForwardRef as ReactComponent };